/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Shortform_To_ListInputs */



/**
* | output |
* | --- |
* | "Add Shortform To List" |
*
* @param {Add_Shortform_To_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add_shortform_to_list = /** @type {((inputs?: Add_Shortform_To_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Shortform_To_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'abréviation à la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform zur Liste hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi abbreviazione all'elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить короткую форму в список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar formato abreviado a la lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将缩写添加到列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストにショートフォームを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची में संक्षिप्त रूप जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar abreviatura à lista")
	return /** @type {LocalizedString} */ ("Add Shortform To List")
});